module.exports = __webpack_public_path__ + "img/风险评估.aae8ee04.png";